<template>
  <div class="app-container">
    <td>
      <img class :src="preCoverUrl" style="width:100%;display:block" v-show="preCoverUrl && isTyping!=1" />
      <!-- <img
        class
        src="../../assets/images/logo.png"
        style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"
      /> -->
    </td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->
    <div class="news-detail" v-show="isTyping == 1">
      <div class="content" v-html="contentType"></div>
    </div>
    <div class="content" v-show="isTyping == 1">
      <typing-first id="first" ref="first" @getResultA='getPercent' />
          <typing-first-b id="firstB" ref="first-b" v-if="isShow" @getFirstB="getFirstB" />
          <typing-second id="second" ref="second" v-if="isShow" @getAnswerSencond="getAnswerSencond"/>
          <typing-third id="third" ref="third" @getAnswerThird="getAnswerThird" :num="isShow ? 4 : 2" />
          <typing-fourth id="fourth" ref="fourth" v-if="answerThird > 0" @getAnswerFourth="getAnswerFourth" :num="isShow ? 5 : 3" />
    </div>
    <div>
      <div class="news-detail">
<!--        <div class="title" v-html="meetingName.replace(/\n|\r\n/g, '<br>')"></div>-->
<!--        <div class="examType">{{ examType === 'beh' ? '会后调研' : '会前调研' }}</div>-->
        <div class="content" v-html="preRemark"></div>
      </div>
      <van-cell-group v-for="(item, index) in questions" :key="index" class="cell-group">
        <div class="question"><span>{{index + 1}}.</span><span v-html="item.question.replace(/\n|\r\n/g, '<br>')"></span>
        <span v-if="item.type === 'RADIO'">(单选)</span>
        <span v-if="item.type === 'CHECKBOX'">(多选)</span>
        </div>
        <van-radio-group v-if="item.type === 'RADIO'" v-model="item.answer">
          <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
            <van-radio :name="option.seq">{{option.seq}}<strong>.</strong>&nbsp;{{ option.value }}</van-radio>
            <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
            <van-field v-if="option.value.indexOf('原因是')>-1" v-model="item.reason" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
            <van-field v-if="option.value.indexOf('工具为')>-1" v-model="item.tools" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
          </div>
        </van-radio-group>
        <van-checkbox-group v-if="item.type === 'CHECKBOX'" v-model="item.answer">
          <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
            <van-checkbox shape="square" :name="option.seq">{{option.seq}}<strong>.</strong>&nbsp;{{ option.value }}</van-checkbox>
            <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
          </div>
        </van-checkbox-group>
        <van-field v-if="item.type === 'TEXT'" rows="3" autosize type="textarea" v-model="item.answer" value=""/>
      </van-cell-group>

    </div>
      
    <div style="margin-top:20px;text-align:center;background:#fff">
      <van-button  @click="handleSubmit()" class="button" color="#8259E1">提交</van-button>
    </div>
      <van-dialog v-model="show" title="提示" show-cancel-button confirm-button-text='是' cancel-button-text='否' @confirm="confirm1">
          <div style="margin:20px">确定不使用食物回避（包括母亲饮食回避）进行诊断？</div>
      </van-dialog>
  </div>
</template>
<script>
import API from '@/api/common';
import wx from 'weixin-js-sdk'
import typingFirst from "./components/question/typingFirst";
import typingFirstB from "./components/question/typingFirstB";
import typingSecond from "./components/question/typingSecond";
import typingThird from "./components/question/typingThird";
import typingFourth from "./components/question/typingFourth";
export default {
  name: "exam",
    components: {
        typingFirst,
        typingFirstB,
        typingSecond,
        typingThird,
        typingFourth
    },
  data() {
    return {
      skip: '1',
      name: 'first',
      show: false,
      isShow: null,
      isFourthShow: false,
      isSecondShow: false,
      answerFirstB: '',
      answerSencond: '',
      answerThird: '',
      answerFourth: '',
      preCoverUrl: '',
      content: '',
      behCoverUrl: '',
      defaultCoverUrl: require('../../assets/images/top.jpg'),
      meetingName: '',
      openid: this.$route.query.openid,
      meetingId: this.$route.query.meetingId,
      examId: this.$route.query.examId,
      examType: this.$route.query.examType,
      questions: [],
      preRemark: '',
      behRemark: '',
      isTyping: '',
      contentType: '<p>尊敬的老师：</p><p>您好！为了更好的了解<strong>食物过敏临床诊疗情况</strong>，提供更专业的服务，惠及更多食物过敏患儿，希望能够占用您约5分钟时间，协助完成以下问卷。该问卷<strong>所有问答仅用于统计分析，答案没有对错，请根据您的临床实际情况放心填写！</strong></p><p>非常感谢您的支持！</p>',
    }
  },
  created() {
    this.init();
      this.$nextTick(()=>{
        this.isShow = this.$refs.first.answerObj.answers[3].checked;
      })
  },
  methods: {
      confirm1() {
          this.skip = '2'
          this.show  = false
          this.saveValue()
      },
      getPercent(e) {
        this.isShow = e.includes(4) ? true : false;
      },
      getFirstB(e) {
        this.isSecondShow = true;
      },
      getAnswerSencond(e) {
        this.answerSencond = e
      },
      getThirdPercent(e) {
        this.isFourthShow = e
      },
      getAnswerThird(e) {
        this.answerThird = e
      },
      getAnswerFourth(e) {
        this.answerFourth = e
      },
      toTyping(value) {
        document.querySelector(value).scrollIntoView({
          behavior: "smooth"
        });
        if (value == '#first') {
          this.$refs.first.confirm = 'confirm'
        } else if (value == '#firstB') {
          this.$refs['first-b'].confirm = 'confirm'
        } else if (value == '#second') {
          this.$refs.second.confirm = 'confirm'
        } else if (value == '#third') {
          this.$refs.third.confirm = 'confirm'
        } else if (value == '#fourth') {
          this.$refs.fourth.confirm = 'confirm'
        }
    },
    init() {
      this.wxInstance();
      console.log('openid:' + this.openid)
      console.log('meetingId:' + this.meetingId)
      console.log('examId:' + this.examId)
      this.getMeeting(this.meetingId)

    },
    getMeeting(meetingId) {
      API.getCityMeeting(this.openid,meetingId).then(result => {
        this.preCoverUrl = result.data.preCoverUrl
        if(result.data.behCoverUrl){
          this.behCoverUrl = result.data.behCoverUrl
        }
        if(result.data.behRemark){
          this.behRemark = result.data.behRemark
        }
        this.meetingName = result.data.tbTitle
        document.title = result.data.tbTitle
        this.preRemark = result.data.preRemark
        // this.content = '各位老师您好：为了解您在本次培训课程的学习情形及效果，为优化后期课程提供依据，烦请您抽空填写本问卷，非常感谢！'
        if(result.data.isTyping == '1' && result.data.needFillTyping == '1'){
          // this.findExamAndTyping(this.examId)
          //根据用户的openid获取用户是否填写过问卷

          this.isTyping = '1'
            //新分型
            this.findExam(this.examId)
        }else{
          this.findExam(this.examId)
        }
      })
    },
    wxInstance(){
      let params = {id: this.meetingId,examType:this.examType,signCodeUrl: location.href.split('#')[0]}

      let title = '调研';
      if(this.examType === 'pre') {
        title = '会前调研';
      }
      if(this.examType === 'beh') {
        title = '会后调研';
      }
      API.getSignature(params).then(res => {
        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['updateAppMessageShareData']
        });
        wx.ready(function () {
          var shareData = {
            title: title,
            desc: res.data.meetingName,
            link: res.data.url,
            imgUrl: res.data.imgUrl,
            success: function () {
            }
          };
          wx.updateAppMessageShareData(shareData);
        });
      });
    },
    findExam(examId) {
      API.findExam(examId).then(result => {
        API.getCustomerInfo(this.openid).then(result1 => {
          console.info(result1)
          let customerInfo = result1.data
          this.questions = result.data.questionList
          this.questions.forEach( item => {
            if (item.type == 'RADIO') {
              item.answer = ''
            } else if (item.type == 'CHECKBOX') {
              item.answer = []
            } else if (item.type == 'TEXT' && item.question ==='专家姓名') {
              item.answer = customerInfo.tbName
            } else if (item.type == 'TEXT' && item.question ==='专家医院') {
              item.answer = customerInfo.hosName
            } else if (item.type == 'TEXT' && item.question ==='专家科室') {
              item.answer = customerInfo.department
            }
          })
        })
      })
    },
    findExamAndTyping(examId) {
      API.findExamAndTyping(examId).then(result => {
        API.getCustomerInfo(this.openid).then(result1 => {
          console.info(result1)
          let customerInfo = result1.data
          this.questions = result.data.questionList
          this.questions.forEach( item => {
            if (item.type == 'RADIO') {
              item.answer = ''
            } else if (item.type == 'CHECKBOX') {
              item.answer = []
            } else if (item.type == 'TEXT' && item.question ==='专家姓名') {
              item.answer = customerInfo.tbName
            } else if (item.type == 'TEXT' && item.question ==='专家医院') {
              item.answer = customerInfo.hosName
            } else if (item.type == 'TEXT' && item.question ==='专家科室') {
              item.answer = customerInfo.department
            }
          })
        })
      })
    },
    valid() {
      let valid = true
      this.questions.forEach( item => {
        if (item.type == 'RADIO' && !item.answer) {
          valid = false
        } else if (item.type == 'CHECKBOX' && !item.answer.length > 0) {
          valid = false
        } else if (item.type == 'TEXT' && !item.answer) {
          valid = false
        }
      })
      return valid
    },
    handleSubmit() {
      if (this.valid()) {
        if(this.isTyping == 1){
          let firstFlag = false;
          this.$refs.first.answerObj.answers.map(item => {
            if (item.checked) {
              firstFlag = true;
            }
          })
          if (firstFlag) {
            this.saveValue()
          } else {
            this.$message.error('第一题必选！')
          }
          
        } else {
            this.saveValue()
        }
      } else {
        this.$message.error('还有问题未填写')
      }
    },
    getFirstBValue() {
      let firstB = this.$refs['first-b'].answerObj;
      console.log(firstB.remark)
      if (firstB.remark == '建议回避2-6周时进行随诊') {
          firstB.value = '1'
      } else if (firstB.remark == '建议至少回避6周以后（如2个月、3个月）再进行随诊') {
          firstB.value = '2'
      } else if (firstB.remark == '没有明确时间，患儿如果有需要可以来复诊') {
          firstB.value = '3'
      }
    },
    getFourthValue() {
      let fourth = this.$refs.fourth.answerObj;
      console.log(fourth.remark)
      if (fourth.remark == 'A、1~2个月') {
          fourth.value = '1'
      } else if (fourth.remark == 'B、3~4个月') {
          fourth.value = '2'
      } else if (fourth.remark == 'C、5~6个月') {
          fourth.value = '3'
      } else if (fourth.remark == 'D、6个月及以上') {
          fourth.value = '4'
      } 
    },
    saveValue() {
        let questionList = []
        this.questions.forEach(item => {
            let question = {stockId: item.stockId, answer: item.answer.toString(), otherAnswer: item.otherAnswer || item.reason || item.tools }
            questionList.push(question)
        })
        const openid = this.openid
        const meetingId = this.meetingId
        const examId = this.examId
        const examType = this.examType
        let params = {meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList};
        if (this.isTyping == 1) {
          if (this.skip == 2) {
            let first = this.$refs.first;
            params = {
                meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList,
                typingList: [
                    first.answerObj, this.$refs.third.answerObj]
            }
            this.saveResult(params)
          } else {
            // this.getFirstBValue()
            //判断第二题有没有填
            if (this.isShow) {
              if (this.$refs['first-b'].answerObj.value !== '') {
                //判断typing-second这个组件是否显示
                if (this.$refs.second.answerObj.value !== '') {
                  if (this.$refs.third.answerObj.value !== '') {
                    //判断typing-fourth这个组件是否显示
                    if (this.$refs.third.answerObj.value > 0) {
                      this.getFourthValue()
                      //判断第五题有没有填
                      if (this.$refs['fourth'].answerObj.remark) {
                        params = {
                          meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList,
                          typingList: [
                          this.$refs.first.answerObj,
                          this.$refs['first-b'].answerObj,
                          this.$refs.second.answerObj,
                          this.$refs.third.answerObj,
                          this.$refs.fourth.answerObj]
                        }
                        this.saveResult(params)
                      } else {
                        this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                      }
                    } else {
                      let params = {
                          meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList,
                          typingList: [
                          this.$refs.first.answerObj,
                          this.$refs['first-b'].answerObj,
                          this.$refs.second.answerObj,
                          this.$refs.third.answerObj]
                        }
                      this.saveResult(params)
                    }
                  } else {
                    this.$message.error(`第${this.isShow?'四':'二'}题必选！`)
                  }
                } else {
                  this.$message.error('第三题必选！')
                }
                  
              } else {
                this.$message.error('第二题必选！')
              }
            } else {
              if (this.$refs.third.answerObj.value !== '') {
                if (this.$refs.third.answerObj.value > 0) {
                  this.getFourthValue()
                  //判断第五题有没有填
                  if (this.$refs['fourth'].answerObj.remark) {
                    params = {
                      meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList,
                      typingList: [
                      this.$refs.first.answerObj,
                      this.$refs.third.answerObj,
                      this.$refs.fourth.answerObj]
                    }
                    this.saveResult(params)
                  } else {
                    this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                  }
                } else {
                  let params = {
                      meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList,
                      typingList: [
                      this.$refs.first.answerObj,
                      this.$refs.third.answerObj]
                    }
                  this.saveResult(params)
                }
              } else {
                this.$message.error('第二题必选！')
              }
            }
          }
        } else{
          this.saveResult(params)
        }
        
    },
    checkConfirm() {
      let form = this.$refs.confirm.form
      if (form.confirm1 == 1 && form.confirm4 == 1 && 
        ((this.isShow && form.confirm2 == 1) || !this.isShow) && 
        ((this.isSecondShow && form.confirm3 == 1) || !this.isSecondShow) && 
        ((this.isFourthShow && form.confirm5 == 1) || !this.isFourthShow)
      ) {
        return true
      }
      return false
    },
    saveResult(params) {
      if (this.checkConfirm) {
        API.saveResult(params).then(data => {
            if (data.success) {
                this.$router.push({
                    name: 'submitSuccess',
                    query: { openid: this.openid, meetingId: this.meetingId, examId: this.examId, examType: this.examType }
                });
            } else {
                this.$message.error(data.message)
            }
        })
      } else {
        this.$message.error(`分型题目再次确认全部选择是才可以提交！`)
      }
    }
  }
}
</script>
<style lang="less">
  strong {
    color: purple;
  }
  p {
    margin: 0;
  }
</style>
<style lang='less' scoped>
.app-container{
  .banner {
    width: 100%;
    height: auto;
  }
  /deep/textarea{
    border:1px solid #ccc;
  }
  .button {
    width: 90%;
    margin: 25px auto;
    border-radius: 6px;
  }
  /deep/.van-cell-group{
    .question{
      font-size: 14px;
      padding: 5px 0;
    }
    .van-radio{
      margin:8px 0;
      font-size: 14px;
    }
    .van-checkbox__label{
      margin:8px;
      font-size: 14px;
    }
    margin:10px 20px;
    padding: 10px;
    border-radius: 5px;
    color: #646566;
  }
  .news-detail {
    height: 100%;
    margin-top: 20px;
    padding-bottom: 10px;
    overflow: auto;
    box-sizing: border-box;
    color: #646566;
    .title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
    }
    .examType {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
    }
    .content {
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

</style>
<style lang="less">
.content {
  .van-field__label {
    margin-left: 6px;
  }

  .van-icon__image {
    width: 18px;
    height: 18px;
  }
  .van-radio__label {
    color: #646566;
  }
}
</style>
